import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AcademyPage, LegalPage, Main, UniversalLink } from '../component'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/academy" element={<AcademyPage />} />
      <Route path="/contact" element={<Main scrollTo="contact" />} />
      <Route path="/terms" element={<LegalPage docKey="terms" />} />
      <Route path="/privacy" element={<LegalPage docKey="privacy" />} />
      <Route path="/universal-link" element={<UniversalLink />} />
    </Routes>
  )
}

export default PrivateRoutes